<template>
  <div class="order-detail d-flex flex-column scroll-container">
    <v-container fluid class="d-flex flex-column scroll-container" v-if="order">
      <v-row>
        <v-col
          v-if="isAuthenticated"
          class="hidden-sm-and-down MenuNavigator"
          cols="0"
          md="3"
        >
          <MenuNavigator class="menu-navigator" />
        </v-col>
        <v-col cols="12" :md="isAuthenticated ? 9 : 12">
          <div class="d-flex flex-row w-100 justify-space-between">
            <ProfileTitle
              :category="category"
              class="justify-start d-flex w-100"
            />
          </div>
          <OrderDetailInfo
            class="mb-4"
            :order="order"
            @addAllToCart="addAllToCart"
            @deleteOrder="deleteOrder"
            @editOrder="editOrder"
            @showPayment="showPayment = !showPayment"
            :hasReserveButton="hasReserveButton"
            :isMobile="isMobile"
          />
          <OrderInvoice
            v-if="isAuthenticated"
            :order="order"
            class="mt-4"
          ></OrderInvoice>
          <PaymentTypeList
            v-if="showPayment"
            :orderId="order.orderId"
            :options="{
              showRememberCard: false,
              showPaymentMethodImage: true,
              showCardLogos: true,
              orderAmount: cart.totalPrice,
              showPrebilledAmountInfoText: true,
              showPrebilledAmountHtml: true,
              showAddNewCardWarning: false,
              confirm: { color: 'secondary' },
              back: {
                class: 'back-btn'
              },
              titleStyle:
                'primary--text text--darken-2 text-h5 px-4 font-weight-bold mb-2'
            }"
          />

          <!-- <OrderInfoSummary :order="order" :delivered="delivered" /> -->
          <OrderDetailTable
            :items="itemList"
            :delivered="delivered"
            :order="order"
          ></OrderDetailTable>

          <v-row
            class="actions-buttons footer-btn justify-center"
            v-if="isAuthenticated"
          >
            <v-btn
              outlined
              color="primary"
              class="bg-white"
              x-large
              depressed
              @click.prevent.stop="historyBack"
            >
              TORNA AI MIEI ORDINI
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-spacer class="spacer-scroll"></v-spacer>
    <FabButton v-if="hasReserveButton && isMobile" :order="order" />
  </div>
</template>
<style scoped lang="scss">
.payment-type-list-container {
  background-color: var(--v-grey-lighten3) !important;
}
</style>
<script>
// @ is an alias to /src
import OrderDetailTable from "@/components/orders/OrderDetailTable.vue";
import OrderDetailInfo from "@/components/orders/OrderDetailInfo.vue";
// import OrderInfoSummary from "@/components/orders/OrderInfoSummary.vue";
import OrderInvoice from "@/components/orders/OrderInvoice.vue";
import PaymentTypeList from "~/components/payment/PaymentTypeList.vue";
import MenuNavigator from "@/components/profile/MenuNavigator.vue";
import ProfileTitle from "@/components/profile/ProfileTitle.vue";

import OrderService from "~/service/orderService";
import AnalyticsService from "~/service/analyticsService";
import categoryMixins from "~/mixins/category";
import reload from "~/mixins/reload";
import get from "lodash/get";
import FabButton from "@/components/buttons/FabButton.vue";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "Order",
  data() {
    return {
      review: {
        rating: 3,
        comment: "",
        active: 1,
        title: "",
        noteId: null,
        productId: -1
      },
      order: null,
      itemList: [],
      valid: true,
      showPayment: false,
      requiredRules: [v => !!v || "Campo obbligatorio"]
    };
  },
  mixins: [categoryMixins, reload],
  components: {
    OrderDetailInfo,
    OrderDetailTable,
    PaymentTypeList,
    FabButton,
    // OrderInfoSummary,
    OrderInvoice,
    MenuNavigator,

    ProfileTitle
  },
  props: { ordersAllUsers: { type: Boolean, default: false } },
  computed: {
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    hasReserveButton() {
      return (
        (this.order?.orderStatusId == 6 || this.order?.orderStatusId == 18) &&
        this.order?.isParkingEnabled
      );
    },
    ...mapGetters({
      isAuthenticated: "cart/isAuthenticated"
    }),
    canIRateOrder() {
      return this.order.orderStatusId === 8 || this.order.orderStatusId === 18;
    },
    enableSave() {
      return !this.valid;
    },
    delivered() {
      // return false;
      //decommentare per mostrare i campi delivered
      return (
        this.order.orderStatusId == 6 ||
        this.order.orderStatusId == 8 ||
        this.order.orderStatusId == 18
      );
    },
    shippingAddress() {
      let shippingAddress = get(this.order, "shippingAddress");
      if (shippingAddress) {
        return this.$t(
          "navbar.address." + shippingAddress.addressTypeId + ".format",
          shippingAddress
        );
      } else {
        return this.$t("navbar.noShippingAddress");
      }
    },
    serviceImg() {
      return this.$t(
        "navbar.service." +
          this.order.shippingAddress.deliveryServiceId +
          ".icon",
        {
          color: "color"
        }
      );
    }
  },
  methods: {
    historyBack() {
      window.history.back();
    },
    am_pm_to_hours(time) {
      var hours = Number(time.match(/^(\d+)/)[1]);
      var minutes = Number(time.match(/:(\d+)/)[1]);
      var AMPM = time.match(/\s(.*)$/)[1];
      if (AMPM == "PM" && hours < 12) hours = hours + 12;
      if (AMPM == "AM" && hours == 12) hours = hours - 12;
      var sHours = hours.toString();
      var sMinutes = minutes.toString();
      if (hours < 10) sHours = "0" + sHours;
      if (minutes < 10) sMinutes = "0" + sMinutes;
      return sHours + ":" + sMinutes;
    },
    ...mapActions({
      addProductsFromOrder: "cart/addProductsFromOrder",
      loadCart: "cart/loadCart"
    }),
    addAllToCart({ orderId }) {
      this.addProductsFromOrder(orderId);
    },
    async deleteOrder({ orderId }) {
      let res = await this.$dialog.confirm({
        text: global.vm.$t("message.removeOrder", {
          orderId: orderId
        })
      });

      if (res) {
        await OrderService.deleteOrder(orderId);
        AnalyticsService.refund(this.order);
        this.itemList = [];
        await this.reload(orderId);
      }
    },
    async editOrder({ orderId }) {
      await OrderService.editOrder(orderId);
      this.loadCart();
      this.$router.push({
        name: "Checkout"
      });
    },
    async reload(orderId) {
      let _this = this;
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("access_token");
      if (token && token.length > 0) {
        const res = await OrderService.getOrderWithToken(orderId, token, true);
        if (res.orderId) {
          this.order = res;
        } else {
          this.$router.push("/orders-anon/invalid-data");
        }
      } else {
        this.order = await OrderService.getOrder(orderId, true);
      }
      handleItems(this.order.suborders, this.itemList);

      function handleOrderItem(orderItem, type) {
        var q2 =
          (orderItem.deliveredQuantity > 0
            ? orderItem.deliveredQuantity
            : orderItem.deliveredWeight) || 0;

        orderItem.deliveredType =
          q2 == 0 &&
          _this.order.orderStatusId < 10 &&
          _this.order.orderStatusId > 13
            ? "replaced"
            : type;

        orderItem.deliveredItem = {
          product: orderItem.product,
          quantity: orderItem.deliveredQuantity,
          weight: orderItem.deliveredWeight
        };

        return orderItem;
      }

      function handleItems(suborders, itemList) {
        for (var s = 0; s < suborders.length; s++) {
          var suborder = suborders[s];
          for (var i = 0; i < suborder.suborderItems.length; i++) {
            var item = suborder.suborderItems[i];
            if (!item.orderItemReplacedId) {
              var alternatives = [];
              var type = "ordered";
              for (var j = 0; j < suborder.suborderItems.length; j++) {
                var itemAlternative = suborder.suborderItems[j];
                if (
                  itemAlternative.orderItemReplacedId &&
                  item.orderItemId == itemAlternative.orderItemReplacedId
                ) {
                  //alternative = itemAlternative;
                  alternatives.push(itemAlternative);
                  type = "replaced";
                  // break;
                }
              }
              itemList.push(handleOrderItem(item, type));
              console.log("BBB", alternatives);
              if (alternatives) {
                alternatives.forEach(alternative => {
                  itemList.push(handleOrderItem(alternative, "alternative"));
                });
              }
            }
          }
        }
      }
    }
  },
  created() {
    this.reload(this.$route.params.orderId);
    console.log(this);
  }
};
</script>
